import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsPageView() {
  const location = useLocation();

  useEffect(() => {
    // Track hash changes too (landing uses anchor navigation like /#waitlist).
    const path = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
    // Dynamic import keeps mixpanel-browser (~20 KB gz) out of the main chunk.
    void import("@/lib/analytics").then((m) => m.trackPageView(path));
  }, [location.pathname, location.search, location.hash]);

  return null;
}
